<template lang="pug">
  .wt-make-an-entry-modal
    .modal-card
      BLoading(
        :class="{'is-loading-active': makeAnEntryJournalLoading}"
        v-if="isJournal"
        :active.sync="makeAnEntryJournalLoading"
        :is-full-page="false"
      )
        //- note, WtTile employs the same template as this
        .is-syncing-loader.has-text-weight-bold.is-size-1 Syncing...
      .modal-card-head
        .columns.is-mobile
          .column.is-narrow.head-column-custom.is-hidden-mobile
            WtTitle(card-title-large).is-size-4-mobile {{ headerText }}
            .active-wellness-challenge-metric-info.is-flex(v-if="showWellnessMetrics && !_.isEmpty(metricsActive) && isJournal")
              BIcon( icon="star" size="" type="is-warning")
              p Earn Wellness Challenge points.
          .column.is-narrow.head-column-custom
            BField.make-an-entry-datepicker-field
              BDatepicker.make-an-entry-datepicker(
                v-if="isJournal"
                ref="datepicker"
                :value="entryItemDateObject"
                @input="fetchEntryItem"
                :focused-date="new Date()"
                :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                :min-date="minDate"
                :max-date="moment()._d"
                icon="calendar-today"
              )
              WtTitle(card-title v-else).is-size-4-mobile.mt-1.ml-3.mb-3 {{ date(entryItemDateObject, 'DATE_FORMAT_SHORT_MONTH').formatted }}
          WtIconButton.close-button(@click.native="$parent.close()" aria-label="Close modal")
            BIcon(icon="close-circle" type="is-grey-light" size="is-medium")
      .modal-card-body.modal-card-body-custom
        BTabs.b-tabs-custom(
          v-if="!makeAnEntryJournalLoading && readyToRender"
          :animated="false"
          :value="activeTab"
          @change="uniqueKey += activeTab"
          :vertical="!isMobile"
        )
          BTabItem.tab-item-custom(v-for="tab in tabs" :key="tab.component + uniqueKey")
            component.make-an-entry-body(
              :is="tab.component"
              :type="type"
              :fetch-action="fetchAction()"
              :entry-item="entryItemLocal"
              :entry-date="date(entryItemDateObject).formatted"
              :form-data="formData"
              :save-entry-wrapper="saveEntryWrapper"
              :unique-key="tab.component + uniqueKey"
              @totalSteps="totalSteps = $event"
              @formDataUpdated="disableSave=false,disableReset=false"
              @formReset="disableSave=true,disableReset=true"
              :disableSave="disableSave"
              :disableReset="disableReset"
              @visibilityUpdated="visibilityUpdated = $event"
              :visibilityUpdated="visibilityUpdated"
              @textVisibilityUpdated="textVisibilityUpdated = $event"
              :textVisibilityUpdated="textVisibilityUpdated"
            )
            template(slot="header")
              .level
                .level-left
                  .level-item
                      .is-relative
                        BIcon.active-metric-icon(
                          v-if="showWellnessMetrics && tab.metricIsActive && isJournal"
                          icon="star"
                          type="is-warning"
                        )
                        WtSvgIcon(:icon="tab.icon" width="32px" height="32px" :class="tab.iconClass")
                  .level-item.is-hidden-mobile
                    .has-text-weight-bold.is-size-7 {{ tab.label }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { pointsMixin } from "@/mixins/pointsMixin";
import WtButton from "@@/WtButton/WtButton";
import WtIconButton from "@@/WtIconButton/WtIconButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import MakeAnEntryActivity from "@@/Members/MakeAnEntry/MakeAnEntryActivity";
import MakeAnEntryPhoto from "@@/Members/MakeAnEntry/MakeAnEntryPhoto";
import MakeAnEntryJournalText from "@@/Members/MakeAnEntry/MakeAnEntryJournalText";
import MakeAnEntrySleep from "@@/Members/MakeAnEntry/MakeAnEntrySleep";
import MakeAnEntryNutrition from "@@/Members/MakeAnEntry/MakeAnEntryNutrition";
import MakeAnEntryWeight from "@@/Members/MakeAnEntry/MakeAnEntryWeight";
import MakeAnEntryMindfulness from "@@/Members/MakeAnEntry/MakeAnEntryMindfulness";
import MakeAnEntryWater from "@@/Members/MakeAnEntry/MakeAnEntryWater";
import MakeAnEntryMood from "@@/Members/MakeAnEntry/MakeAnEntryMood";
import MakeAnEntryHeart from "@@/Members/MakeAnEntry/MakeAnEntryHeart";

export default {
  name: "MakeAnEntryModal",

  components: {
    WtButton,
    WtIconButton,
    WtTitle,
    WtSvgIcon,
    MakeAnEntryActivity,
    MakeAnEntryPhoto,
    MakeAnEntryJournalText,
    MakeAnEntrySleep,
    MakeAnEntryNutrition,
    MakeAnEntryWeight,
    MakeAnEntryMindfulness,
    MakeAnEntryWater,
    MakeAnEntryMood,
    MakeAnEntryHeart
  },

  mixins: [dateUtilityMixin, pointsMixin],

  props: {
    activeTab: {
      type: Number,
      default: 0
    },

    entryItem: {
      type: Object,
      default: () => {}
    },

    // "journal" or "discussion"
    type: {
      type: String,
      default: "journal"
    },

    // needed for editing discussion
    entityId: {
      type: Object,
      default: () => {}
    },

    photosOnly: {
      type: Boolean,
      default: false
    },

    friends: {
      type: Boolean,
      default: false
    },

    currentPage: {
      type: Number,
      default: 1
    },

    isMakeAnEntry: {
      type: Boolean,
      default: false
    },
    canDisplayPhoto: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      formData: new FormData(),
      disableSave: true,
      disableReset: true,
      uniqueKey: "",
      totalSteps: 0,
      fetchEntryItemDateObject: this.today().dateObject,
      visibilityUpdated: 2,
      textVisibilityUpdated: 0,
      readyToRender: false
    };
  },

  computed: {
    ...mapGetters("program", ["isCoreTier"]),
    ...mapGetters("members", [
      "makeAnEntryJournal",
      "makeAnEntryJournalLoading"
    ]),
    ...mapGetters(["isMobile"]),

    showWellnessMetrics() {
      return this.isJournal && this.$auth.user().program.isWellnessMetricsOn;
    },

    isJournal() {
      return this.type === "journal";
    },

    isDiscussion() {
      return this.type === "discussion";
    },

    entryItemLocal() {
      if (this.isMakeAnEntry) {
        let journalEntry = {};
        if (Array.isArray(this.makeAnEntryJournal)) {
          journalEntry = this.makeAnEntryJournal[0];
        } else if (
          this.makeAnEntryJournal &&
          typeof this.makeAnEntryJournal === "object"
        ) {
          journalEntry = this.makeAnEntryJournal;
        }
        return journalEntry;
      }
      return this.entryItem;
    },

    entryItemDateObject() {
      if (this._.isEmpty(this.entryItemLocal)) {
        return this.fetchEntryItemDateObject;
      }

      if (this.isDiscussion) {
        return this.unixDateTime(this.entryItemLocal.postedDate).dateObject;
      }

      return this.date(this.entryItemLocal.created).dateObject;
    },

    headerText() {
      if (this.isJournal) {
        let action = this._.isEmpty(this.makeAnEntryJournal)
          ? "Add New"
          : "Update";
        if (
          this.date(this.entryItemDateObject).formatted ===
          this.today().formatted
        ) {
          return `${action} Entry For Today`;
        }
        return `${action} Entry`;
      }
      if (this.isDiscussion) {
        return `Edit Comment`;
      }
      return "Make an Entry";
    },

    minDate() {
      // members shouldn't be allowed to enter steps before their registration date.
      // note, the datepicker min-date prop is not inclusive,
      // hence 15 instead of 14 for two weeks and subtract(1) from registered date
      const registered = this.unixDateTime(this.$auth.user().registeredDate)
        .dateObject;
      const twoWeeks = this.moment().subtract(15, "days")._d;

      if (this.moment(registered).isAfter(twoWeeks)) {
        return this.moment(registered).subtract(1, "days")._d;
      }

      return twoWeeks;
    },

    wellnessChallengeMetricsTracking() {
      return this.$auth
        .user()
        .challenges.filter(challenge => challenge.isWellness)
        .map(challenge => {
          return challenge.metricsTracking;
        });
    },

    metricsActive() {
      let allMetricsOn = this.wellnessChallengeMetricsTracking.map(
        challengeMetricsTracking => {
          let metricsOn = [];

          // Catch, "TypeError: Object.entries requires that input parameter not be null or undefined"
          if (this._.isEmpty(challengeMetricsTracking)) return metricsOn;

          Object.entries(challengeMetricsTracking).forEach(([metric, isOn]) => {
            if (isOn) metricsOn.push(metric);
          });
          return metricsOn;
        }
      );

      return this._.uniq(this._.flatten(allMetricsOn));
    },

    tabs() {
      let topTabs = [
        {
          component: "MakeAnEntryActivity",
          label: "Activities",
          icon: "blue-walk-man-icon",
          iconClass: "",
          display: this.isJournal,
          metricIsActive: this.metricsActive.includes(
            this.pointsForJournalSteps
          )
        },
        {
          component: "MakeAnEntryPhoto",
          label: "Photo",
          icon: "icon_add_image",
          iconClass: "",
          display:
            (this.isJournal || this.isDiscussion) && this.canDisplayPhoto,
          metricIsActive: this.metricsActive.includes(
            this.pointsForJournalPhoto
          )
        },
        {
          component: "MakeAnEntryJournalText",
          label: "Journal Entry",
          icon: "icon_journal_small",
          iconClass: "",
          display: this.isJournal || this.isDiscussion,
          metricIsActive: this.metricsActive.includes(this.pointsForJournalText)
        }
      ].filter(tab => tab.display);
      let wellnessMetricsTabs = [
        {
          component: "MakeAnEntrySleep",
          label: "Sleep",
          icon: "icon_sleep",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessSleep
          )
        },
        {
          component: "MakeAnEntryNutrition",
          label: "Nutrition",
          icon: "icon_add_nutrition",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessNutrition
          )
        },
        {
          component: "MakeAnEntryWeight",
          label: "Weight",
          icon: "icon_add_weight",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessWeight
          )
        },
        {
          component: "MakeAnEntryMindfulness",
          label: "Mindfulness",
          icon: "icon_mindfulness",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessMindfulness
          )
        },
        {
          component: "MakeAnEntryWater",
          label: "Water",
          icon: "icon_add_water",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessWater
          )
        },
        {
          component: "MakeAnEntryMood",
          label: "Mood",
          icon: "icon_add_mood",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessMood
          )
        },
        {
          component: "MakeAnEntryHeart",
          label: "Heart",
          icon: "icon_add_heart",
          iconClass: "",
          display: this.showWellnessMetrics,
          metricIsActive: this.metricsActive.includes(
            this.pointsForWellnessHeart
          )
        }
      ].filter(tab => tab.display);

      // Metrics that are being tracked in an active wellness challenges sort to the top
      return [
        ...topTabs,
        ...wellnessMetricsTabs.sort((tabA, tabB) => {
          // true values first
          return tabA.metricIsActive === tabB.metricIsActive
            ? 0
            : tabA.metricIsActive
            ? -1
            : 1;
        })
      ];
    }
  },

  mounted() {
    setTimeout(async () => {
      // $$ optimize $$
      await this.$nextTick();
      this.readyToRender = true;
    });
  },

  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["fetchAllPageSitewide", "reloadChallengePages"]),
    ...mapActions("members", [
      "fetchJournalPageJournal",
      "fetchMember",
      "fetchMemberStepData",
      "fetchLeaderboard",
      "fetchMakeAnEntryJournalByDate",
      "fetchActivities"
    ]),
    ...mapActions(["members/fetchJournals"]),
    ...mapActions("challenges", ["fetchChallengeDiscussion"]),
    ...mapActions("teams", ["fetchTeamDiscussion"]),

    async fetchEntryItem(date) {
      date = this.date(date);
      this.fetchEntryItemDateObject = date.dateObject;

      const payload = {
        memberId: this.$auth.user().id,
        date: date.formatted
      };

      await this.fetchMakeAnEntryJournalByDate(payload);
      this.refreshModal();
    },

    fetchAfterJournalEntry() {
      const memberId = this.$auth.user().id;

      if (
        this.$route.name === "JournalPage" ||
        this.$route.name === "ProfileJournalPage"
      ) {
        this.fetchJournalPageJournal({
          memberId,
          journalDate: this.makeAnEntryJournal.created
        });
      }

      this.fetchMemberStepData({ memberId });
      this.fetchMember({
        memberId,
        setMember: true
      });
      this["members/fetchJournals"]({
        memberId,
        photosOnly: this.photosOnly,
        friends: this.friends,
        page: this.currentPage
      });
      this.fetchLeaderboard({ memberId });
      this.fetchAllPageSitewide(this.$auth.user().programId);

      this.reloadChallengePages();
    },

    fetchDiscussion() {
      if (this.entityId.type === "challenge") {
        return this.fetchChallengeDiscussion({
          challengeId: this.entityId.id,
          photosOnly: this.photosOnly,
          friends: this.friends,
          page: this.currentPage
        });
      }
      if (this.entityId.type === "team") {
        return this.fetchTeamDiscussion({
          teamId: this.entityId.id,
          photosOnly: this.photosOnly,
          page: this.currentPage
        });
      }
    },

    fetchAction() {
      if (this.isJournal) {
        return this.fetchAfterJournalEntry;
      }
      if (this.isDiscussion) {
        return this.fetchDiscussion;
      }
    },

    updateTodaysSteps() {
      if (
        this.date(this.entryItemDateObject).formatted ===
          this.today().formatted &&
        this.isJournal
      ) {
        // walkData will be null for member with no entries, ie new-registrant, new-program-created-admin
        this.$set(
          this.$auth.user(),
          "walkData.todaysStepsAndActivities",
          this.totalSteps
        );
      }
    },

    async saveEntryWrapper(storeAction, updateAction) {
      this.formData.set(
        "date",
        this.date(this.entryItemDateObject, "DATE_FORMAT_DB").formatted
      );
      if (this.isDiscussion) {
        this.formData.set(this.entityId.type + "Id", this.entityId.id);
      }
      const payload = {
        itemId: this.entryItemLocal.id,
        memberId: this.$auth.user().id,
        formData: this.formData
      };

      let response;

      if (
        (this._.isEmpty(this.makeAnEntryJournal) && this.isJournal) ||
        (this._.isEmpty(this.entryItem) && this.isDiscussion)
      ) {
        this.updateTodaysSteps();
        response = await storeAction(payload);
      } else {
        this.updateTodaysSteps();
        response = await updateAction(payload);
      }

      if (response.error) {
        let message = this._.get(response, "error.message", "error saving.");
        message = `Oh darn, there was an error:  ${message} Please try again, or reach out to wellness@be-engaged.co.`;

        await this.snackBar({
          type: "is-danger",
          duration: 10000,
          queue: false,
          message
        });
      } else {
        await this.snackBar({
          message: `Your entry is saved!`
        });
        // re-fetch auth user to refresh total points
        await this.$auth.fetch();

        this.refreshModal();

        this.fetchAction()();
      }
    },

    refreshModal() {
      this.formData = new FormData();
      this.disableSave = true;
    }
  }
};
</script>

<style lang="sass" scoped>
// NOTE: some styles exist in wt-styles in order to override bulma defaults
.modal-card
  width: auto
  max-width: 100vw
  height: 70vh
.modal-card, .b-tabs-custom
  min-width: 50vw
  min-height: 60vh
  //max-height: 80vh
  +tablet
    min-height: 30vh
    //max-height: 70vh
  +mobile
    width: 90vw
    min-height: 30vh
    //max-height: 70vh
.modal-card-head
  +mobile
    padding: .5rem
  .head-column-custom
    +mobile
      padding: .5rem
.modal-card-body-custom
  padding: 0
.is-loading-active
.loading-overlay
  height: auto !important
  border-radius: $radius
.modal-card-body-custom
  border-bottom-left-radius: $radius-large
  border-bottom-right-radius: $radius-large
.tab-item-custom
  height: 100%
  .make-an-entry-body
    height: 100%
    display: flex
    flex-direction: column
    justify-content: space-between
.close-button
  position: absolute
  top: .5rem
  right: .5rem
.mindfulness-icon-box
  background-color: $teal
  width: 32px
  height: 32px
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: center

.active-metric-icon
  position: absolute
  bottom: -6px
  left: -6px

.modal-card-body-custom /deep/ .b-tabs.is-vertical > .tabs ul
  min-height: 100%
  max-height: 25rem
  overflow-y: scroll
.modal-card-body-custom .b-tabs.is-vertical
  flex-wrap: nowrap
body > .modal .animation-content .wt-make-an-entry-modal .b-tabs-custom
  min-height: 100%
  height: initial
</style>
